import React from 'react';
import { ScoreCardMetric } from '../types/stockAdvice';
import { ScoreBar } from './ScoreBar';
import { fallbackForLabel, formatLseNumericDisplay, isUnavailableDisplayValue } from './stockAdviceFormatting';

interface MetricScoreCardProps {
  title: string;
  metrics: ScoreCardMetric[];
  exchange: string;
  coverageNote?: string;
}

export const MetricScoreCard: React.FC<MetricScoreCardProps> = ({ title, metrics, exchange, coverageNote }) => (
  <section className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#1b1b2b] to-[#131320] p-4">
    <h4 className="text-sm font-semibold text-white mb-3">{title}</h4>
    {coverageNote ? <p className="text-[11px] text-slate-500 mb-3">{coverageNote}</p> : null}
    <div className="space-y-3">
      {metrics.length ? metrics.map((metric) => {
        const displayValue = metric.value && !isUnavailableDisplayValue(metric.value)
          ? formatLseNumericDisplay(metric.value, exchange)
          : fallbackForLabel(metric.label);
        const isGenericReason = /limited coverage from available provider data\.?/i.test(metric.reason.trim());
        return (
          <div key={metric.label} className="rounded-2xl border border-white/5 bg-black/20 p-3 space-y-2">
            <div className="flex justify-between items-center gap-2">
              <p className="text-xs text-slate-300">{metric.label}</p>
              <p className="text-xs text-slate-400">{displayValue}</p>
            </div>
            <ScoreBar score={metric.score} />
            {!coverageNote || !isGenericReason ? <p className="text-[11px] text-slate-400 break-words">{metric.reason}</p> : null}
          </div>
        );
      }) : <p className="text-xs text-slate-500">Provider coverage limited</p>}
    </div>
  </section>
);
